function getCookieValue(name){
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

var $getCook = getCookieValue("Sale-password");
if($getCook != "" && $getCook == "pasword-match"){
  document.querySelector(".password_popup").style.display = "none";
  document.querySelector("body").classList.remove("password_popup_open");
}else{
  document.querySelector(".password_popup").style.display = "block";
  document.querySelector("body").classList.add("password_popup_open");
}
document.getElementById("submit_password").addEventListener("click",function(evt){
  var Get_password_value  = document.getElementById("password").value;
  var GetOrignal_password = document.querySelector(".password_popup").getAttribute("data-matchpassowrd");
  if(Get_password_value != "" && Get_password_value == GetOrignal_password){
    setCookie('Sale-password', "pasword-match", 1);
    document.querySelector(".password_reqtrification").style.display = "none";
    document.querySelector(".password_popup").style.display = "none";
    document.querySelector("body").classList.remove("password_popup_open");
    document.body.classList.add("loading-nsl");
    if(window.innerWidth > 767){
      animationFunction();  
    }else{
      animationFunctionMobile();
    }
  }else{
    document.querySelector(".password_reqtrification").style.display = "block";
    document.getElementsByName('password_popup')[0].placeholder='Please enter valid password';
    console.log("password is not matching") 
  }
})
// Set a Cookie
function setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
// Apply setCookie


// animation js starts from here
function animationFunction(){
  var targetValue = 100;
  var currentValue = 0;
  var image_len = $('.loading-images.desktop .image_main').length;
  var ratio_img = (5000/image_len)/2;
  function updatePercentage() {
    $('.loadin-percentage').text(currentValue + '%');
    $('.loading-line span').css({"transform": "scaleX("+(currentValue/100)+")", "transform-origin": "left"});
    if (currentValue < targetValue){
      currentValue++;
      setTimeout(updatePercentage, 20);
      //$('.loading-overlay').css('opacity',(currentValue/100));
    }else{
      $('.loading-line span').css({"transform": "scaleX(0)", "transform-origin": "right"});
      setTimeout(function(e){
        clearInterval(changeClass);
        $(".loading-logo,.loading-images.desktop").fadeOut(1000);
      },1000);
      setTimeout(function(e){$('body').removeClass('loading-nsl');},2000);
    }
  }
  updatePercentage();
  function updateClass(){
    let a = $(".loading-images.desktop .image_main.active");
    a.removeClass("active");
    a = a.next(".loading-images.desktop .image_main");
    if (a.length == 0)
      a = $(".loading-images.desktop .image_main").first();
      a.addClass("active");
  }
  var changeClass = setInterval(function(){updateClass();}, ratio_img);
}
function animationFunctionMobile(){
  var targetValue = 100;
  var currentValue = 0;
  var image_len = $('.loading-images.mobile img').length;
  var ratio_img = (5000/image_len)/2;
  function updatePercentage() {
    $('.loadin-percentage').text(currentValue + '%');
    $('.loading-line span').css({"transform": "scaleX("+(currentValue/100)+")", "transform-origin": "left"});
    if (currentValue < targetValue){
      currentValue++;
      setTimeout(updatePercentage, 20);
      //$('.loading-overlay').css('opacity',(currentValue/100));
    }else{
      $('.loading-line span').css({"transform": "scaleX(0)", "transform-origin": "right"});
      setTimeout(function(e){
        clearInterval(changeClass);
        $(".loading-logo,.loading-images.mobile").fadeOut(1000);
      },1000);
      setTimeout(function(e){$('body').removeClass('loading-nsl');},2000);
    }
  }
  updatePercentage();
  function updateClassMobile(){
    let a = $(".loading-images.mobile img.active");
    a.removeClass("active");
    a = a.next(".loading-images.mobile img");
    if (a.length == 0)
      a = $(".loading-images.mobile img").first();
      a.addClass("active");
  }
  var changeClass = setInterval(function(){updateClassMobile();}, ratio_img);
}


// expiry end date js
// Set the date we're counting down to
  var EndDate = document.querySelector(".password_popup").getAttribute("data-endDay");
  var countDownDate = new Date(EndDate).getTime();
  
  // Update the count down every 1 second
  var x = setInterval(function() {
  
    // Get today's date and time
    var now = new Date().getTime();
      
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
      
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var totalHours = days*24 + hours;
    // Output the result in an element with id="demo"
    document.getElementById("popup_countdown").innerHTML = totalHours +":"+ minutes +":"+ seconds;
      
    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("demo").innerHTML = "EXPIRED";
    }
  }, 1000);